module.exports = __webpack_public_path__ + "img/2.36906ab5.svg";